var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, array_property, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONOnlineArticle extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.contract_class = 0;
        /** @override */ this.cost = 0;
        /** @override */ this.cost_included_vat = 0;
        /** @override */ this.details = [];
        /** @override */ this.duration = 0;
        /** @override */ this.duration_type = '';
        /** @override */ this.eier = 0;
        /** @override */ this.group_ids = [];
        /** @override */ this.id = 0;
        /** @override */ this.is_direct_link_only = false;
        /** @override */ this.is_featured = false;
        /** @override */ this.no_direct_debit = false;
        /** @override */ this.temporary = false;
        /** @override */ this.test_membership = false;
    }
}
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "contract_class", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "cost", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "cost_included_vat", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONOnlineArticle.prototype, "description", void 0);
__decorate([
    array_property(String),
    __metadata("design:type", Array)
], ewJSONOnlineArticle.prototype, "details", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "duration", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewJSONOnlineArticle.prototype, "duration_type", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "eier", void 0);
__decorate([
    array_property(Number),
    __metadata("design:type", Array)
], ewJSONOnlineArticle.prototype, "group_ids", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "id", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONOnlineArticle.prototype, "is_direct_link_only", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONOnlineArticle.prototype, "is_featured", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONOnlineArticle.prototype, "no_direct_debit", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "start_timestamp", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONOnlineArticle.prototype, "stop_timestamp", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONOnlineArticle.prototype, "temporary", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONOnlineArticle.prototype, "test_membership", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONOnlineArticle.prototype, "title", void 0);
